module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.langOpen === 'on'),
      expression: "langOpen==='on'"
    }],
    staticClass: "twui-hovermenu"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lang === 'zh_CN'),
      expression: "lang === 'zh_CN'"
    }],
    on: {
      "click": function($event) {
        return _vm.changeLangEvent('en_US')
      }
    }
  }, [_vm._v("中文")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lang === 'en_US'),
      expression: "lang === 'en_US'"
    }],
    on: {
      "click": function($event) {
        return _vm.changeLangEvent('zh_CN')
      }
    }
  }, [_vm._v("English")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-22645244","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/tw-lang.vue
// module id = 589
// module chunks = 1